import { EventManager } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { DialogParams } from './workspace/database-workspace/components/wms-connect-to-database-dialog/wms-connect-to-database-dialog.component';
import { ServiceInfo } from './workspace/database-workspace/database-workspace.component';
import { runtimeEventManager, SwitchAiStudioEvent } from '@wm/core';

declare const window: any;

@Injectable({
  providedIn: "root"
})
export class EventManagerService implements OnDestroy {
  private resizeSubject: Subject<any>;
  private canvasElDrag: Subject<any>;
  private selectWidgetEvt: Subject<any>;
  private canvasUpdateEvt: Subject<any>;
  private canvasMoveEvt: Subject<any>;
  private canvasAddEvt: Subject<any>;
  private canvasDeleteEvt: Subject<any>;
  private postWidgetDeleteEvt: Subject<any>;
  private widPropChanged: Subject<any>;
  private renderCanvasContent: Subject<any>;
  private beforePgRender: Subject<any>;
  private editorContent: Subject<any>;
  private resetActiveCanvasEl: Subject<any>;
  private reRenderCanvasContent: Subject<any>;
  private markupDirty: Subject<any>;
  private  layoutGridRowAddEvt: Subject<any>;
 private  layoutGridColumnAddEvt: Subject<any>;
 private setMarkupAttr :Subject<any>;
 private partialParamsModifiedEvt: Subject<any>;
 private pgRendered: Subject<any>;
 private pageSave: Subject<any>;
 private prefabDependencyReady: Subject<any>;
 private updatePageTree:Subject<any>;
 private updateResourcesTree:Subject<any>;
 private pgMarkup: Subject<any>;
 private updatePageMinJson: Subject<any>;
 private setActiveWidget: Subject<any>;
 private onPageSave: Subject<any>;
 private embedStudioInit: Subject<any>;
 private canvasElDragEndEvent: Subject<any>;
 private switchPageLayout: Subject<any>;
 private closeCriteriaDialog: Subject<any>;
 private updateCanvasTree: Subject<any>;
 private pageMarkupCacheReset: Subject<any>;
 private viewUpdateOndelete: Subject<any>;
 private loadView: Subject<any>;
 private updateViewSelector: Subject<any>;
 private setEventAttr: Subject<any>;
 private uploadTheme: Subject<any>;
 private uploadType : Subject<any>;
 private selectPage: Subject<any>;
 private jobStatus: Subject<any>;
 private routeHistoryEvent: Subject<any>;
 private routeHistoryListEvent: Subject<any>;
 private setactivews: Subject<any>;
 private javaserviceWsSelect: Subject<any>;
 private javaserviceWsSave: Subject<any>;
 private exportProject: Subject<any>;
 private openDialog:Subject<any>;
 private canvasDomClickEvt: Subject<any>;
 private profileList: Subject<any>;
 private updateTab: Subject<any>;
 private updatePageData: Subject<any>;
 private savePgws: Subject<any>;
 private saveFilews: Subject<any>;
 private keyboardAction: Subject<any>;
 private cacheAPIResponse$: Subject<any>;
 private publishToWorkspace: Subject<any>;
 private viewPort: Subject<any>;
 private publishToTeamInit$: Subject<any>;
 private clearActivews: Subject<any>;
 private updateSupportedLocaleVar: Subject<any>;
 private getLastApiService: Subject<any>;
 private updateRouteHistory: Subject<any>;
 private savesettingsws: Subject<any>;
 private updateActiveTheme: Subject<any>;
 private updateVariableTree: Subject<any>;
 private dbLoaded: Subject<void>;
 private showSpinnerService: Subject<any>;
 private setActiveWSCategory: Subject<string>;
 private saveapiws: Subject<any>;
 private updateMockAPIResponse: Subject<any>;
 private finishMerge: Subject<any>;
 private updateServiceType: Subject<any>;
 private updateActiveNestedTab: Subject<any>
 private iconImport:Subject<any>;
 private iconSave: Subject<any>;
 private pagePermission: BehaviorSubject<any>;
 private studioRefreshQueue: any[] = [];
 private createpartialvariable: Subject<any>;
 private addWidgetEvent: Subject<any>;
 private setActiveprop: Subject<any>;
 private closeDialogWithId: Subject<any>;
 private refreshInspect: Subject<void>;
 private refreshAPIIssues: Subject<void>;
 private fetchAPIIssues: Subject<void>;
 private showGuidedTour: BehaviorSubject<boolean>;
 private documentClick: Subject<any>;
 private openAppIssuesTab : Subject<any>;
 private changeInActiveTab: Subject<string>;
 private reloadAppVariables: Subject<any>;
 private reloadDesignTokens: Subject<any>;
 private importDB: Subject<any>;
 private updateDBServiceTree: Subject<any>;
 private triggerDBNodeOption: Subject<any>;
 private reloadDBServiceTree = new Subject<any>();
 private showTableRelation: Subject<any>;
 private openDBCreateDialog: BehaviorSubject<any>;
 private openJavaServiceCreateDialog: BehaviorSubject<any>;
 private openAPIDesignerDialog: BehaviorSubject<any>;

 private updateVariableTabView: Subject<any>;
 private enableApply : Subject<any>;
 private onTabSwitchForNav :Subject<any>;
 private wizardInnerStep:Subject<any>;
 private exucuteQueryOnDB: Subject<any>;
 private reloadDBSettings: Subject<any>;
 private savestylews: Subject<any>;
private widgetRearrangeSubject: Subject<any>;

 private applyAutolayout: Subject<any>;
 private widgetSelectionCount: Subject<any>;
 private editorCursorChangeEvent: Subject<any>;
 private treeNodeChangeEvent: BehaviorSubject<any>;
 private expandTreeNode: Subject<any>;
 private onTabswitch: Subject<any>;
 private editPageName: Subject<any>;
 private deletePageName:Subject<any>;
 private duplicatePageName: Subject<any>;

 private editorValueChange: Subject<any>;
 private routerChange:Subject<any>;
 private modelClose:Subject<any>;
 private designTab:Subject<any>;
 private pagesTabSwitch: Subject<any>;
 private onEditorWidgetBlur:Subject<any>;
 private switchPropPanelTab: Subject<any>;


  constructor(private eventManager: EventManager) {
    this.resizeSubject = new Subject();
    this.onEditorWidgetBlur = new Subject();
    this.switchPropPanelTab = new Subject();
    this.canvasElDrag = new Subject();
    this.selectWidgetEvt = new Subject();
    this.canvasUpdateEvt = new Subject();
    this.postWidgetDeleteEvt = new Subject();
    this.canvasMoveEvt = new Subject();
    this.canvasAddEvt = new Subject();
    this.canvasDeleteEvt = new Subject();
    this.widPropChanged = new Subject();
    this.renderCanvasContent = new Subject();
    this.reRenderCanvasContent = new Subject();
    this.beforePgRender = new Subject();
    this.editorContent = new Subject();
    this.resetActiveCanvasEl = new Subject();
    this.markupDirty = new Subject();
    this.layoutGridRowAddEvt =new Subject();
    this.layoutGridColumnAddEvt=new Subject();
    this.setMarkupAttr=new Subject();
    this.partialParamsModifiedEvt = new Subject();
    this.pgRendered = new Subject();
    this.pageSave = new Subject();
    this.onPageSave = new Subject();
    this.embedStudioInit = new Subject();
    this.prefabDependencyReady = new Subject();
    this.updatePageTree=new Subject();
    this.updateResourcesTree=new Subject();
    this.pgMarkup = new Subject();
    this.updatePageMinJson = new Subject();
    this.setActiveWidget = new Subject();
    this.switchPageLayout = new Subject();
    this.canvasElDragEndEvent = new Subject();
    this.closeCriteriaDialog = new Subject();
    this.updateCanvasTree = new Subject();
    this.pageMarkupCacheReset = new Subject();
    this.viewUpdateOndelete = new Subject();
    this.loadView = new Subject();
    this.updateViewSelector = new Subject();
    this.setEventAttr = new Subject();
    this.uploadTheme = new Subject();
    this.uploadType = new Subject();
    this.selectPage = new Subject();
    this.routeHistoryEvent = new Subject();
    this.routeHistoryListEvent = new Subject();
    this.setactivews = new Subject();
    this.javaserviceWsSelect = new Subject();
    this.javaserviceWsSave = new Subject();
    this.jobStatus = new Subject();
    this.exportProject = new Subject();
    this.openDialog = new Subject();
    this.canvasDomClickEvt = new Subject();
    this.profileList = new Subject()
    this.updateTab = new Subject();
    this.updatePageData = new Subject();
    this.savePgws = new Subject();
    this.saveFilews = new Subject();
    this.keyboardAction = new Subject();
    this.cacheAPIResponse$ = new Subject();
    this.viewPort = new Subject();
    this.publishToWorkspace = new Subject();
    this.publishToTeamInit$ = new Subject();
    this.clearActivews = new Subject();
    this.updateSupportedLocaleVar = new Subject();
    this.getLastApiService = new Subject();
    this.updateRouteHistory = new Subject();
    this.savesettingsws = new Subject();
    this.updateActiveTheme = new Subject();
    this.updateVariableTree = new Subject();
    this.dbLoaded = new Subject();
    this.showSpinnerService = new Subject();
    this.setActiveWSCategory = new Subject();
    this.saveapiws = new Subject<any>();
    this.updateMockAPIResponse = new Subject();
    this.finishMerge = new Subject();
    this.updateServiceType = new Subject();
    this.updateActiveNestedTab = new Subject();
    this.iconImport = new Subject();
    this.iconSave = new  Subject();
    this.createpartialvariable = new Subject();
    this.refreshInspect = new Subject();
    this.refreshAPIIssues = new Subject();
    this.fetchAPIIssues = new Subject();
    this.showGuidedTour = new BehaviorSubject<boolean>(false);
    this.documentClick = new Subject();
    this.openAppIssuesTab = new Subject();
    this.eventManager.addEventListener(window, 'resize', this.onResize.bind(this));
    this.pagePermission = new BehaviorSubject('');
    this.addWidgetEvent = new Subject();
    this.setActiveprop = new Subject();
    this.closeDialogWithId = new Subject();
    this.changeInActiveTab = new Subject();
    this.reloadAppVariables = new Subject();
    this.reloadDesignTokens = new Subject();
    this.triggerDBNodeOption = new Subject();
    this.importDB = new Subject();
    this.updateDBServiceTree = new Subject();
    this.reloadDBServiceTree = new Subject();
    this.showTableRelation = new Subject();
    this.openDBCreateDialog = new BehaviorSubject('');
    this.openJavaServiceCreateDialog = new BehaviorSubject('');
    this.openAPIDesignerDialog = new BehaviorSubject('');
    this.updateVariableTabView = new Subject();
    this.enableApply = new Subject();
    this.onTabSwitchForNav = new Subject();
    this.wizardInnerStep = new Subject();
    this.exucuteQueryOnDB = new Subject();
    this.reloadDBSettings = new Subject();
    this.savestylews = new Subject();
    this.widgetRearrangeSubject = new Subject();
    this.applyAutolayout = new Subject<any>();
    this.widgetSelectionCount = new Subject<any>();
    this.editorCursorChangeEvent = new Subject<any>();
    this.treeNodeChangeEvent = new BehaviorSubject('');
    this.expandTreeNode = new Subject<any>();
    this.onTabswitch = new Subject();
    this.editPageName = new Subject();
    this.deletePageName = new Subject();
    this.duplicatePageName = new Subject();
    this.editorValueChange = new Subject();
    this.routerChange = new Subject();
    this.modelClose = new Subject();
    this.designTab = new Subject();
    this.pagesTabSwitch = new Subject();

    runtimeEventManager.setService('eventManagerService', this);
  }

  public emitcanvasAddWidgetDragEndEvent() {
    this.canvasElDragEndEvent.next('');
  }

  public canvasAddWidgetDragEndEventObservable() {
    return this.canvasElDragEndEvent.asObservable();
  }

  public emitSetActiveWidget(widgetId: string) {
    return this.setActiveWidget.next(widgetId);
  }

  public setActiveWidgetObservable(): Observable<any> {
    return this.setActiveWidget.asObservable();
  }

  public emitPageMarkupResponse(data: any) {
    return this.pgMarkup.next(data);
  }

  public pageMarkupObservable(): Observable<any> {
    return this.pgMarkup.asObservable();
  }

  public emitUpdatePageMinJson(data: any) {
    return this.updatePageMinJson.next(data);
  }

  public emitOnEditorWidgetBlur(data: any) {
     return this.onEditorWidgetBlur.next(data);
  }

  public onEditorWidgetBlurAsObservable(): Observable<any> {
    return this.onEditorWidgetBlur.asObservable();
  }

  public emitSwitchPropPanel(data: any) {
    return this.switchPropPanelTab.next(data);
  }

  public switchPropPanelAsObservable(): Observable<any> {
    return this.switchPropPanelTab.asObservable();
  }

  public updatePageMinJsonObservable(): Observable<any> {
    return this.updatePageMinJson.asObservable();
  }

  public emitDependencyReady(data: string) {
    return this.prefabDependencyReady.next(data);
  }

  public prefabDependencyReadyObservable() {
    return this.prefabDependencyReady.asObservable();
  }

  public pageRenderedObservable() {
    return this.pgRendered.asObservable();
  }

  public emitPageRenderedEvt(pageName: string) {
    this.pgRendered.next(pageName);
  }

  public partialParamsObservable(): Observable<any> {
    return this.partialParamsModifiedEvt.asObservable();
  }

  public emitPartialParamsChange(data?: any) {
    this.partialParamsModifiedEvt.next(data || '');
  }

  public editorContentObservable(): Observable<any> {
    return this.editorContent.asObservable();
  }

  public emitEditorContent(data?: any) {
    this.editorContent.next(data || '');
  }

  onResize$(): Observable<any> {
    return this.resizeSubject.asObservable();
  }

  onCanvasDrag$(): Observable<any> {
    return this.canvasElDrag.asObservable();
  }

  private onResize(event: UIEvent) {
    this.resizeSubject.next(event.target);
  }

  public onDrag(data: any) {
    this.canvasElDrag.next(data);
  }

  public widgetSelectionObservable(): Observable<any> {
    return this.selectWidgetEvt.asObservable();
  }

  public emitOnWidgetSelection(data?: any) {
    this.selectWidgetEvt.next(data || '');
  }

  public postWidgetDeleteObservable(): Observable<any> {
    return this.postWidgetDeleteEvt.asObservable();
  }

  public emitOnPostWidgetDelete(data: {widgetId: string | undefined, parentWidgetId: string | undefined}) {
    this.postWidgetDeleteEvt.next(data);
  }

  public canvasUpdateObservable(): Observable<any>{
    return this.canvasUpdateEvt.asObservable();
  }

  public emitOnCanvasUpdate(data: any){
    this.canvasUpdateEvt.next(data);
  }

  public updatePageStructureObservable(): Observable<any> {
    return this.updateCanvasTree.asObservable();
  }

  public emitUpdatePageStructure(data?: any) {
   this.updateCanvasTree.next(data);
  }

  public updateViewSelectorObservable(): Observable<any> {
    return this.updateViewSelector.asObservable();
  }

  public emitUpdateViewSelector() {
    this.updateViewSelector.next('');
  }

  public canvasMoveObservable(): Observable<any>{
    return this.canvasMoveEvt.asObservable();
  }

  public emitOnCanvasMove(data: any){
    this.canvasMoveEvt.next(data);
  }

  public canvasDeleteObservable(): Observable<any> {
    return this.canvasDeleteEvt.asObservable();
  }

  public emitOnCanvasDelete(data: any) {
    this.canvasDeleteEvt.next(data);
  }

  public canvasAddObservable(): Observable<any>{
    return this.canvasAddEvt.asObservable();
  }

  public emitOnCanvasAdd(data: any){
    this.canvasAddEvt.next(data);
  }

  public widgetPropChangedObservable(): Observable<any>{
    return this.widPropChanged.asObservable();
  }

  public layoutGridRowAddObservable(data?: any) {
    return this.layoutGridRowAddEvt.asObservable();
  }

  public emitOnlayoutGridRowAdd(data?: any) {
    this.layoutGridRowAddEvt.next(data);
  }

  public layoutGridColumnAddObservable(data?: any) {
    return this.layoutGridColumnAddEvt.asObservable();
  }

  public emitOnlayoutGridColumnAdd(data?: any) {
    this.layoutGridColumnAddEvt.next(data);
  }

  public setMarkupAttrObservable(): Observable<any> {
    return this.setMarkupAttr.asObservable();
  }

  public emitSetMarkupAttr(event: string, widgetId: any, attrs: any, childSelector: string) {
    this.setMarkupAttr.next({event, widgetId, attrs, childSelector});
  }

  public setEventAttrObservable(): Observable<any> {
    return this.setEventAttr.asObservable();
  }

  public emitSetEventAttr(event: string, widgetId: any, attrs: any, childSelector: string) {
    this.setEventAttr.next({event, widgetId, attrs, childSelector});
  }

  public emitOnWidgetPropChanged(data: boolean) {
    this.widPropChanged.next(data);
  }

  // public renderCanvasContentObservable(): Observable<any> {
  //   return this.renderCanvasContent.asObservable();
  // }

  // public emitRenderCanvasContent(markup: string, pageName: string, content?: any, isUpdated?: boolean) {
  //   this.renderCanvasContent.next({markup, pageName, content, isUpdated});
  // }

  public reRenderCanvasContentObservable(): Observable<any> {
    return this.reRenderCanvasContent.asObservable();
  }

  public emitReRenderCanvasContent(data: {pageName: string, isMarkupUpdated: boolean}) {
    this.reRenderCanvasContent.next(data);
  }

  public beforePageRenderObservable(): Observable<any> {
    return this.beforePgRender.asObservable();
  }

  public emitBeforePageRender(pageName: string) {
    this.beforePgRender.next(pageName);
  }

  public resetActiveCanvasElObservable(): Observable<any> {
    return this.resetActiveCanvasEl.asObservable();
  }

  public emitResetActiveCanvasEl(content: any) {
    this.resetActiveCanvasEl.next(content);
  }

  public canvasMarkupDirtyObservable(): Observable<string> {
    return this.markupDirty.asObservable();
  }

  public emitOnCanvasMarkupDirty(data: string) {
    this.markupDirty.next(data);
  }

  public pageSaveObservable(): Observable<any> {
    return this.pageSave.asObservable();
  }

  public emitPageSave(data?: boolean) {
    this.pageSave.next(data);
  }
  public emitUpdatePageTree(data?:any){
    this.updatePageTree.next(data);
  }
  public UpdatePageTreeObservable():Observable<any>{
    return this.updatePageTree.asObservable()
  }
  public emitUpdateResourcesTree(data?:any){
    this.updateResourcesTree.next(data);
  }
  public UpdateResourcesTreeObservable():Observable<any>{
    return this.updateResourcesTree.asObservable()
  }

  public emitSwitchPageLayout(layout: any) {
    return this.switchPageLayout.next(layout);
  }

  public switchPageLayoutObservable(): Observable<any> {
    return this.switchPageLayout.asObservable();
  }

  public onPageSaveObservable(): Observable<string> {
    return this.onPageSave.asObservable();
  }
  public emitOnPageSave(pageName: string) {
    this.onPageSave.next(pageName);
  }

  public emitCloseCriteriaDialog(id: string) {
    this.closeCriteriaDialog.next(id);
  }
  public closeCriteriaDialogObservable(): Observable<string> {
    return this.closeCriteriaDialog.asObservable();
  }

  public emitPageMarkupCacheReset(pageName: string) {
    this.pageMarkupCacheReset.next(pageName);
  }
  public pageMarkupCacheResetObservable(): Observable<string> {
    return this.pageMarkupCacheReset.asObservable();
  }

  public emitViewUpdateOnDelete(data: any) {
    this.viewUpdateOndelete.next(data);
  }
  public viewUpdateOnDeleteObservable(): Observable<string> {
    return this.viewUpdateOndelete.asObservable();
  }

  public emitLoadView(data: any) {
    this.loadView.next(data);
  }
  public loadViewObservable(): Observable<string> {
    return this.loadView.asObservable();
  }

  public getUploadedTheme(data: any) {
    this.uploadTheme.next(data);
  }
  public uploadedThemeObservable(): Observable<string> {
    return this.uploadTheme.asObservable();
  }
  public emitSelectPage(data: string) {
    this.selectPage.next(data);
  }
  public selectPageObservable(): Observable<string> {
    return this.selectPage.asObservable();
  }
  public emitJobStatus(data?: any) {
    this.jobStatus.next(data);
  }
  public jobStatusObservable(): Observable<any> {
    return this.jobStatus.asObservable();
  }


  public emitRouteHistoryChange(data: any) {
    this.routeHistoryEvent.next(data);
  }
  public routeHistoryObservable() {
    return this.routeHistoryEvent.asObservable();
  }

  public emitRouteHistoryListChange(data: any) {
    this.routeHistoryListEvent.next(data);
  }
  public routeHistoryListObservable() {
    return this.routeHistoryListEvent.asObservable();
  }

  public emitSetActiveWs(data: any) {
    this.setactivews.next(data);
  }
  public setActiveWsObservable() {
    return this.setactivews.asObservable();
  }

  public emitJavaserviceSave(data: any) {
    this.javaserviceWsSave.next(data);
  }
  public javaserviceSaveObservable() {
    return this.javaserviceWsSave.asObservable();
  }

  public emitJavaserviceSelect(data: any) {
    this.javaserviceWsSelect.next(data);
  }
  public javaserviceSelectObservable() {
    return this.javaserviceWsSelect.asObservable();
  }

  public emitExportProjectAsShell(data?: any) {
    this.exportProject.next(data);
  }

  public exportProjectAsShellObservable() {
    return this.exportProject.asObservable();
  }

  public emitOpenDialogWithID(data: any) {
    this.openDialog.next(data);
  }
  public openDialogWithIDObservable() {
    return this.openDialog.asObservable();
  }

  public emitCanvasDomClick(data: any) {
    this.canvasDomClickEvt.next(data);
  }
  public canvasDomClickObservable() {
    return this.canvasDomClickEvt.asObservable();
  }

  public emitProfiles(data: any) {
    this.profileList.next(data);
  }
  public profilesObservable() {
    return this.profileList.asObservable();
  }

  public emitUpdateTabOnWs(data: any) {
    this.updateTab.next(data);
  }
  public updateTabOnWsObservable() {
    return this.updateTab.asObservable();
  }

  public emitUpdatePageData(data: any) {
    this.updatePageData.next(data);
  }
  public updatePageDataObservable() {
    return this.updatePageData.asObservable();
  }

  public emitSavePageWorkspace(data: any) {
    this.savePgws.next(data);
  }
  public savePageWorkspaceObservable() {
    return this.savePgws.asObservable();
  }

  public emitSaveFileWorkspace(data: any) {
    this.saveFilews.next(data);
  }
  public saveFileWorkspaceObservable() {
    return this.saveFilews.asObservable();
  }

  public emitKeyboardAction(data: any) {
    this.keyboardAction.next(data);
  }
  public keyboardActionObservable() {
    return this.keyboardAction.asObservable();
  }

  public emitCacheAPIResponse(data: any) {
    this.cacheAPIResponse$.next(data);
  }

  public cacheAPIResponseObservable() {
    return this.cacheAPIResponse$.asObservable();
  }
  public emitViewportSelection(data: any) {
    this.viewPort.next(data);
  }
  public viewportSelectionObservable() {
    return this.viewPort.asObservable();
  }
  public emitPublishToWorkspace(data: any) {
    this.publishToWorkspace.next(data);
  }
  public publishToWorkspaceObservable() {
    return this.publishToWorkspace.asObservable();
  }
  public emitupdateMockAPIResponse(data: string) {
    this.updateMockAPIResponse.next(data);
  }
  public updateMockAPIResponseObservable() {
    return this.updateMockAPIResponse.asObservable();
  }
  public emitUpdateSupportedVar(data: any) {
    this.updateSupportedLocaleVar.next(data);
  }
  public updateSupportedVarObservable() {
    return this.updateSupportedLocaleVar.asObservable();
  }

  public emitPublishToTeamInit() {
    this.publishToTeamInit$.next('');
  }
  public publishToTeamInitObservable() {
    return this.publishToTeamInit$.asObservable();
  }

  public emitClearActivews(data: any) {
    this.clearActivews.next(data);
  }
  public clearActivewsObservable() {
    return this.clearActivews.asObservable();
  }

  public emitGetLastApiService(data: any) {
    this.getLastApiService.next(data);
  }
  public getLastApiServiceObservable() {
    return this.getLastApiService.asObservable();
  }

  public emitupdateRouteHistory(data: any) {
    this.updateRouteHistory.next(data);
  }
  public updateRouteHistoryObservable() {
    return this.updateRouteHistory.asObservable();
  }
  public emitupdateActiveTheme(data: any) {
    this.updateActiveTheme.next(data);
  }
  public updateActiveThemeObservable() {
    return this.updateActiveTheme.asObservable();
  }


  public emitSaveSettingWS(data: any) {
    this.savesettingsws.next(data);
  }
  public saveSettingWSobservable() {
    return this.savesettingsws.asObservable();
  }

  public emitSaveStyleWS(data: any) {
    this.savestylews.next(data);
  }

  public saveStyleWSobservable() {
    return this.savestylews.asObservable();
  }

  public emitSaveApiWS(data: any) {
    this.saveapiws.next(data);
  }
  public saveApiWSObservable() {
    return this.saveapiws.asObservable();
  }

  public emitUpdateVariableTree(data?: any){
    return this.updateVariableTree.next(data);
  }

  public updateVariableTreeObs(){
    return this.updateVariableTree.asObservable();
  }

  public emitDBLoaded() {
    this.dbLoaded.next();
  }
  public dbLoadedObservable() {
    return this.dbLoaded.asObservable();
  }

  public emitopenAppIssuesTab(id:any) {
    this.openAppIssuesTab.next(id);
  }
  public showOpenIssueTabObservable() {
    return this.openAppIssuesTab.asObservable();
  }

  public emitShowSpinnerService(spinnerMsg: any) {
    this.showSpinnerService.next(spinnerMsg);
  }
  public showSpinnerServiceObservable() {
    return this.showSpinnerService.asObservable();
  }

  public emitSetActiveWSCategory(category: string) {
    this.setActiveWSCategory.next(category);
  }
  public setActiveWSCategoryObservable() {
    return this.setActiveWSCategory.asObservable();
  }

  public emitFinishMergeInit(){
    this.finishMerge.next('')
  }

  public finishMergeInitObservable(){
    return this.finishMerge.asObservable()
  }

  public emitupdateServiceType() {
    this.updateServiceType.next('');
  }
  public updateServiceTypesObservable() {
   return this.updateServiceType.asObservable();
  }
  public emitCreatepartialvariable(data: any){
    this.createpartialvariable.next(data);
  }
  public createpartialvariableObservable() {
    return this.createpartialvariable.asObservable();
  }

  public emitUpdateNestedTab(nestedTabPath: string){
    this.updateActiveNestedTab.next(nestedTabPath);
  }

  public updateNestedTabObservable(){
    return this.updateActiveNestedTab.asObservable();
  }
  public emitOnIconImport() {
    this.iconImport.next("");
  }
  public updateOnIconImport() {
    return this.iconImport.asObservable();
  }
  public emitOnIconSave() {
    this.iconSave.next("");
  }
  public updateOnIconSave() {
    return this.iconSave.asObservable();
  }
  public emitRefreshInspect() {
    this.refreshInspect.next();
  }
  public refreshInspectObservable() {
   return this.refreshInspect.asObservable();
  }

  public emitRefreshAPIIssues() {
    this.refreshAPIIssues.next();
  }
  public refreshAPIIssuesObservable() {
   return this.refreshAPIIssues.asObservable();
  }

  public emitFetchAPIIssues(id:any) {
    this.fetchAPIIssues.next(id);
  }
  public fetchAPIIssuesObservable() {
   return this.fetchAPIIssues.asObservable();
  }

  public emitShowGuidedTour(value: boolean) {
    this.showGuidedTour.next(value);
  }
  public showGuidedTourObservable() {
   return this.showGuidedTour.asObservable();
  }

  public emitDocumentClick(target: any) {
    this.documentClick.next(target);
  }
  public documentClickObservable() {
   return this.documentClick.asObservable();
  }

  public emitpagePermission() {
    this.pagePermission.next('');
  }
  public pagePermissionsObservable() {
    return this.pagePermission.asObservable();
  }

  public pushToStudioRefreshQueue(data: any) {
    // Always enqueue (so missed updates can be replayed)
    this.studioRefreshQueue.push(data);
  }

  consumeStudioRefreshQueue(): any[] {
    return this.studioRefreshQueue;
  }
  public emitaddWidgetEvent(data: any) {
    this.addWidgetEvent.next(data);
  }
  public addWidgetEventAsObservable() {
    return this.addWidgetEvent.asObservable();
  }

  public emitsetActiveprop(data: string) {
    this.setActiveprop.next(data);
  }
  public setActivepropObservable() {
    return this.setActiveprop.asObservable();
  }

  public emitcloseDialogWithId(data: any) {
    this.closeDialogWithId.next(data);
  }
  public closeDialogWithIdAsObservable() {
    return this.closeDialogWithId.asObservable();
  }

  public emitchangeInActiveTab(data: string) {
    this.changeInActiveTab.next(data);
  }
  public changeInActiveTabAsObservable() {
    return this.changeInActiveTab.asObservable();
  }
  public emitEnableApplyButton(data: any) {
    this.enableApply.next(data);
  }
  public EnableApplyButton() {
    return this.enableApply.asObservable();
  }

  public emitReloadAppVariables() {
    this.reloadAppVariables.next('');
  }
  public reloadAppVariablesAsObservable() {
    return this.reloadAppVariables.asObservable();
  }

  public emitReloadDesignTokens() {
    this.reloadDesignTokens.next('');
  }

  public reloadDesignTokensAsObservable() {
    return this.reloadDesignTokens.asObservable();
  }

  public emitTriggerDBNodeOption(nodeDetails:any){
    this.triggerDBNodeOption.next(nodeDetails);
  }

  public triggerDBNodeOptionAsObservable() {
    return this.triggerDBNodeOption.asObservable();
  }

  public emitImportDB(instructions: DialogParams) {
    this.importDB.next(instructions);
  }

  public importDBAsObservable() {
    return this.importDB.asObservable();
  }


  public emitUpdateDBServiceTree(serviceInfo: ServiceInfo) {
    this.updateDBServiceTree.next(serviceInfo);
  }

  public updateDBServiceTreeAsObservable() {
    return this.updateDBServiceTree.asObservable();
  }

  public emitReloadDBServiceTree(serviceInfo: any) {
    this.reloadDBServiceTree.next(serviceInfo);
  }

  public reloadDBServiceTreeAsObservable() {
    return this.reloadDBServiceTree.asObservable();
  }

  public emitShowTableRelation(serviceInfo: any) {
    this.showTableRelation.next(serviceInfo);
  }

  public showTableRelationAsObservable() {
    return this.showTableRelation.asObservable();
  }

  public emitopenDBCreateDialog(serviceInfo: any) {
    this.openDBCreateDialog.next(serviceInfo);
  }

  public openDBCreateDialogAsObservable() {
    return this.openDBCreateDialog.asObservable();
  }

  public  emitOpenJavaSerivceCreateDialog(serviceInfo: any) {
     this.openJavaServiceCreateDialog.next(serviceInfo);
  }

  public openJavaServiceCreateDialogAsObservable() {
    return this.openJavaServiceCreateDialog.asObservable();
  }

  public emitOpenAPIDesignerDialog(serviceInfo: any) {
    this.openAPIDesignerDialog.next(serviceInfo);
  }

  public openAPIDesignerDialogAsObservable() {
    return this.openAPIDesignerDialog.asObservable();
  }



  public emitUpdateVariableTabView() {
    this.updateVariableTabView.next('');
  }
  public updateVariableTabViewAsObservable() {
    return this.updateVariableTabView.asObservable();
  }

  public emitOnTabSwitchForNav() {
    this.onTabSwitchForNav.next('');
  }
  public updateOnTabSwitchForNav() {
    return this.onTabSwitchForNav.asObservable();
  }
  public emitWizardInnerStep(data:string){
    this.wizardInnerStep.next(data);
  }
  public updateWizardInnerStep(){
    return this.wizardInnerStep.asObservable();
  }

  public emitExecuteQueryOnDB(){
    this.exucuteQueryOnDB.next("");
  }

  public executeQueryOnDB(){
    return this.exucuteQueryOnDB.asObservable();
  }
  public emitReloadSettings(data: string) {
    this.reloadDBSettings.next(data);
  }

  public reloadSettingsObservable() {
    return this.reloadDBSettings.asObservable();
  }

  public widgetRearrangeObservable(): Observable<any>{
    return this.widgetRearrangeSubject.asObservable();
  }

  public emitOnwidgetRearrange(data: any){
    this.widgetRearrangeSubject.next(data);
  }

  public emitApplyAutolayout(data: any) {
    this.applyAutolayout.next(data);
  }

  public applyAutolayoutObservable(): Observable<any> {
    return this.applyAutolayout.asObservable();
  }

  public emitWidgetSelectionCount(data: any) {
    this.widgetSelectionCount.next(data);
  }

  public widgetSelectionCountObservable(): Observable<any> {
    return this.widgetSelectionCount.asObservable();
  }

  public emitEditorCursorChangeEvent(data: any) {
    this.editorCursorChangeEvent.next(data);
  }

  public editorCursorChangeEventObservable(): Observable<any> {
    return this.editorCursorChangeEvent.asObservable();
  }

   public emitTreeNodeChangeEvent(data: any) {
    this.treeNodeChangeEvent.next(data);
  }

  public treeNodeChangeEventObservable(): Observable<any> {
    return this.treeNodeChangeEvent.asObservable();
  }

  public emitExpandTreeNodeEvent(data : any){
    this.expandTreeNode.next(data);
  }

  public expandTreeNodeEventObservable(): Observable<any> {
    return this.expandTreeNode.asObservable();
  }


  emitOnTabswitch(data: any) {
    this.onTabswitch.next(data);
  }
  onTabswitchObservable() {
    return this.onTabswitch.asObservable();
  }

  emitOnEditPageName(data: any){
    this.editPageName.next(data);
  }
  onEditPageName(){
    return this.editPageName.asObservable();
  }


  emitOnDeletePage(data: any){
    this.deletePageName.next(data);
  }
onDeletePage(){
    return this.deletePageName.asObservable();
}

  emitOnPageDuplicate(data: any){
    this.duplicatePageName.next(data);
  }
  onPageDuplicate(){
    return this.duplicatePageName.asObservable();
  }
emitOnRouterChange(data:any){
    this.routerChange.next(data);
}
onRouterChange(){
    return this.routerChange.asObservable();
}




emitEditorValueChanges(data:any){
    this.editorValueChange.next(data);
}
editorValueChanges(){
    return this.editorValueChange.asObservable();
}
emitOnClickOfDesignTab(){
    this.designTab.next('');
}
onClickOfDesignTab(){return this.designTab.asObservable();
}
emitOnModelClose(){
    this.modelClose.next('');
}
onModelClose(){
    return this.modelClose.asObservable();
}

 public emitPageTabChange(data: any) {
    this.pagesTabSwitch.next(data);
  }

  public pageTabChangeObservable(): Observable<any> {
    return this.pagesTabSwitch.asObservable();
  }
  ngOnDestroy(): void {

  }
}
